
import { UserCache } from "../../caches";
import { BaseClientService } from "../base-client.service";
import { ControllerOptions, DataController } from "../../../types";
import { AppUser, UserService } from "@nt-portal/server-sdk";

export interface AppUserOptions extends ControllerOptions<AppUser> {

}


export class ClientUserService extends BaseClientService implements DataController<AppUser> {

    private _usersService: UserService;

    constructor() {
        super();
        this._usersService = new UserService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }


    public async currentUser(): Promise<AppUser | null> {

        let user = await this._usersService.getMe(this.token) as AppUser;
        return user;


    }

    public async getMe(): Promise<AppUser | null> {

        let idToken = UserCache.idToken;
        if (idToken) {
            let user = await this._usersService.getMe(idToken) as AppUser;
            return user;
        } else {
            return null

        }
    }

    public async syncRoles(): Promise<AppUser | null> {

        let user = await this._usersService.syncRoles(this.token) as AppUser;
        return user;

    }

    public static displayName(user?: AppUser | null): string {
        if (user) {

            if (user.name)
                return user.name;
            return user.email ?? '';
        }
        return '';
    }



    public async get(options: AppUserOptions) {
        let fetchParams = this.buildFetchParams(options)
        return await this._usersService.get(fetchParams, this.token, options.filter);
    }

    public async update(options: AppUserOptions): Promise<AppUser | AppUser[] | null> {
        if (options.item)
            return await this._usersService.update(options.item, this.token)
        return null;
    }

    public async getLookup(options: AppUserOptions) {
        let fetchParams = this.buildLookupFetchParams(options)
        return await this._usersService.get(fetchParams, this.token, options.filter);
    }


    public async getById(options: AppUserOptions): Promise<AppUser | null> {
        try {
            if (options.id) {
                let user = await this._usersService.getById(options.id, this.token) as AppUser;
                return user;
            }
            return null;
        }
        catch (ex) {
            return null;
        }

    }

    public async resetPassword(resetKey: string, password: string) {
        return await this._usersService.resetPassword(resetKey, password, this.token)

    }


    public async unlockUser(options: AppUserOptions) {
        if (options.id)
            return await this._usersService.unlockUser(options.id, this.token)
        else throw new Error("User ID is required to unlock user");
    }

}